export function requestChatMessage(
  member,
  contextId,
  reqForm,
  avayaTeam,
  avayaReason,
) {
  return {
    method: 'requestChat',
    deviceType: navigator.userAgent,
    routePointIdentifier: 'Default',
    workFlowType: '',
    requestTranscript: false,
    workRequestId: contextId,
    calledParty: window.location.href,
    leaseTime: 1,
    intrinsics: {
      channelAttribute: 'Chat',
      textDirection: document.dir.toUpperCase(),
      attributes: [avayaTeam, avayaReason],
      email: reqForm.emailAddress,
      name: member.firstName,
      lastName: member.lastName,
      phoneNumber: member.phoneNumber,
      customFields: [],
    },
    priority: 1,
    customData: {},
  };
}
//# sourceMappingURL=requests-model.js.map
